<template>

    <div style="margin-top:2%;text-align:center" class="w100"
         v-if="vuexGetters_patientDetailText!=null&&vuexGetters_patientDetailText.Patient!=null && !isErrorPage">
        <h2>Açıklama</h2>
        <label>
            Sayın {{vuexGetters_patientDetailText.Patient.PatientName}} {{this.vuexGetters_patientDetailText.Patient.PatientSurname}}, {{vuexGetters_patientDetailText.RequestingPhysician}} ile {{vuexGetters_patientDetailText.RequestDate.replace("T"," ")}} tarihinde olan randevunuzu iptal etmek istediğinize emin misiniz?
        </label>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <Button class="p-button-danger" style="margin-right:20px;" @click="confirmCancel()">Evet</Button>
        <Button class="p-button-secondary" @click="goToMainPage()">Hayır</Button>
        <ConfirmDialog></ConfirmDialog>

    </div>
    <div v-else>
        Hata oluştu.
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";

    export default {
        data() {
            return {
                data: null,
                isErrorPage:false
            }
        },
        computed: {
            ...mapGetters(["vuexGetters_patientDetailText"]),
        },
        methods: {
            ...mapActions(["vuexActions_patientDetails", "vuexActions_cancelAppointment"]),
            goToMainPage() {
                this.$router.push("/");
            },
            confirmCancel() {
                this.$confirm.require({
                    message: 'Randevunuzu iptal etmek istediğinize emin misiniz?',
                    header: 'Dikkat',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.vuexActions_cancelAppointment({ ...this.data })
                    },
                    reject: () => {
                    }
                });
            },
        },
        mounted() {
            let hash = location.hash.split('#')[2].split('|');
            
            if (hash.length == 3) {

                this.data = {
                    accessionNumber: hash[0],
                    orderId: hash[1],
                    orderScheduleId: hash[2],
                }

                this.vuexActions_patientDetails(this.data);
                this.isErrorPage = false;
            } else {
                this.isErrorPage = true;
                /*this.goToMainPage();*/
            }
        }
    }
</script>

<style>
    label {
        font-size: 1rem !important;
        font-weight: 500 !important;
    }
</style>

